import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomErrorStateMatcher } from '../../models/custom-error-state';
import { IItem } from '../../models/group-edit-config';

@Component({
  selector: 'app-input-edit-helper',
  templateUrl: './input-edit-helper.component.html',
  styleUrls: ['./input-edit-helper.component.scss']
})
export class InputEditHelperComponent implements OnInit {
    @Input() control!: FormControl;
    @Input() errorState = new CustomErrorStateMatcher();

    localConfig!: IItem;
    @Input() set config(_c : IItem){
        this.localConfig = _c;
    }

    constructor() { }

    ngOnInit(): void {
    }

}
